import React from "react";
import AddIcon from "@material-ui/icons/Add";
import { CircularProgress, Box, makeStyles, Button } from "@material-ui/core";

const useStyles = makeStyles({
    imgContainer: {
        width: "3rem",
        height: "3rem",
        marginRight: "1.5rem",
    },
    container: {
        display: "flex",
        alignItems: "center",
    },
});

export const imageCompanyRenderer = (
    value,
    name,
    updateImage,
    imageIsLoading,
    mutable,
    acceptExtensions = ".svg",
) => {
    const classes = useStyles();

    const changeImgHandler = (e) => {
        updateImage(name, e.target.files[0]);
    };

    let fieldProps = {
        type: "file",
        hidden: true,
        accept: acceptExtensions,
    };

    let urlValue = value;

    // Creates url from File instance
    if (value instanceof File) {
        urlValue = URL.createObjectURL(value);
    }

    if (value?.base64str) {
        urlValue = value?.base64str;
    } else {
        urlValue = `${window.location.origin}/${urlValue}`;
    }

    return imageIsLoading ? (
        <CircularProgress size={30} />
    ) : (
        <Box className={classes.container} mr={1}>
            {value ? (
                <Box className={classes.imgContainer} mr={1}>
                    <img
                        style={{
                            maxWidth: "200px",
                            maxHeight: "100%",
                            backgroundColor: "black",
                        }}
                        src={urlValue}
                        alt="Image Error"
                    />
                </Box>
            ) : (
                <div>Нет изображения </div>
            )}

            {mutable && (
                <React.Fragment>
                    <input
                        id="category-img"
                        {...fieldProps}
                        onChange={changeImgHandler}
                    />
                    <label
                        style={{ marginLeft: "100px" }}
                        htmlFor="category-img"
                    >
                        <Button
                            startIcon={<AddIcon />}
                            component="span"
                            variant="contained"
                        >
                            Загрузить изображение
                        </Button>
                    </label>
                </React.Fragment>
            )}
        </Box>
    );
};
